
import Vue from "vue";
import { Component, Mixins, Prop } from "vue-property-decorator";
import UnitConverter from '../../mixins/unitConverter'

@Component({
})
export default class Depthsummary extends Mixins(UnitConverter) {
  @Prop({})
  dailyReport!:any;

  @Prop({}) 
  currentHoleSize!:any;
  @Prop({}) 
  currentDepth!:any;
  @Prop({}) 
  previousDepth!:any;
  @Prop({}) 
  depthProgress!:any;
  @Prop({}) 
  totalDepth!:any;
  @Prop({}) 
  actualTotalDepth!:any;
  @Prop({}) 
  casingSize!:any;
  @Prop({}) 
  casingDepth!:any;
  @Prop({}) 
  topOfLiner!:any;
  @Prop({default: 'Conductor'}) 
  casingType!:any;
  @Prop({}) 
  lot!:any;
  @Prop({}) 
  fit!:any;
  @Prop({}) 
  isChecked!:boolean;

  private get currentHoleSizeInput() {
    return this.currentHoleSize;
  }
  private set currentHoleSizeInput(depth:any) {
    this.$emit("update:currentHoleSize", depth);
  }
  private get currentDepthInput() {
    return this.currentDepth;
  }
  // private set currentDepthInput(depth:any) {
  //   this.$emit("update:currentDepth", depth);
  // }
   private get previousDepthInput() {
    return this.previousDepth;
  }
  private set previousDepthInput(date:any) {
    this.$emit("update:previousDepth", date);
  }
   private get depthProgressInput() {
    return this.depthProgress;
  }
  private set depthProgressInput(time:any) {
    this.$emit("update:depthProgress", time);
  }
  private get totalDepthInput() {
    return this.totalDepth;
  }
  private set totalDepthInput(time:any) {
    this.$emit("update:totalDepth", time);
  }
  private get actualTotalDepthInput() {
    return this.actualTotalDepth;
  }
  private set actualTotalDepthInput(time:any) {
    this.$emit("update:actualTotalDepth", time);
  }
  private get casingSizeInput() {
    return this.casingSize;
  }
  private set casingSizeInput(size:any) {
    this.$emit("update:casingSize", size);
  }
  private get casingDepthInput() {
    return this.casingDepth;
  }
  private set casingDepthInput(depth:any) {
    this.$emit("update:casingDepth", depth);
  }
  private get topOfLinerInput() {
    return this.topOfLiner;
  }
  private set topOfLinerInput(depth:any) {
    this.$emit("update:topOfLiner", depth);
  }
  private get casingTypeInput() {
    return this.casingType;
  }
  private set casingTypeInput(type:any) {
    this.$emit("update:casingType", type);
  }
  private get lotInput() {
    return this.lot;
  }
  private set lotInput(time:any) {
    this.$emit("update:lot", time);
  }
  private get fitInput() {
    return this.fit;
  }
  private set fitInput(time:any) {
    this.$emit("update:fit", time);
  }
  mounted() {
    this.$emit('current-depth-change');
  }
  activated() {
    this.$emit('current-depth-change');
  }
}
